<template>
  <v-container fluid class="scroll">
    <v-card :loading="triggerEventsLoading">
      <v-toolbar color="primary" dark>
        Trigger Events
        <!-- <v-spacer></v-spacer>
        <v-text-field
          v-model="searchEvents"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>-->
      </v-toolbar>
      <expandedToolbar
        :changeDateRange="true"
        :dateRangeFilter="filter"
        @changeDateRangeClick="dateRangeDialog = true"
      />
      <v-card-text v-if="triggerEvents">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            lg="2"
            xl="1"
            :key="i"
            v-for="(item, i) in triggerEvents"
          >
            <v-card class="mx-auto" max-width="400" tile>
              <v-img
                @click="viewDetails(item)"
                style="cursor: pointer"
                height="200px"
                :src="`https://flexi-comms-trigger-events${
                  apiUrl == 'https://api.flexi-comms.com' ? '-live' : ''
                }.s3.ap-southeast-2.amazonaws.com/${item.id}-triggerEvent.${
                  item.imageType
                }`"
              ></v-img>
              <v-card-text @click="viewDetails(item)" style="cursor: pointer">
                <p>Device {{ item.device_id }}</p>
                <p>{{ getDateLocal(item.created_at) }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="mb-2"
                  color="primary"
                  text
                  @click="downloadEventAttachment(item)"
                  >Download Attachment</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Trigger Event #{{ event.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="viewDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-img
          :src="`https://flexi-comms-trigger-events${
            apiUrl == 'https://api.flexi-comms.com' ? '-live' : ''
          }.s3.ap-southeast-2.amazonaws.com/${event.id}-triggerEvent.${
            event.imageType
          }`"
        ></v-img>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <p class="pb-0 mb-0 font-weight-black">Date / Time</p>
                <p class="mb-0">{{ getDateLocal(event.created_at) }}</p>
              </v-col>
              <v-col cols="12">
                <p class="pb-0 mb-0 font-weight-black">Device</p>
                <p class="mb-0">{{ event.device_id }}</p>
              </v-col>
              <v-col cols="12">
                <p class="pb-0 mb-0 font-weight-black">Trigger Count</p>
                <p class="mb-0">{{ event.triggers }}</p>
              </v-col>
              <v-col cols="12">
                <p class="pb-0 mb-0 font-weight-black">Session Number</p>
                <p class="mb-0">{{ event.sessions }}</p>
              </v-col>
              <v-col cols="12">
                <p class="pb-0 mb-0 font-weight-black">Meta Data</p>
                <p class="mb-0">{{ event.metaData }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dateRangeDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Date Range
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              filter.dateRange = dateRange;
              dateRangeDialog = false;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-date-picker
                  :landscape="$vuetify.breakpoint.smAndUp"
                  full-width
                  elevation="0"
                  v-model="filter.dateRange"
                  range
                ></v-date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="setDateRange()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import AppBar from "@/components/AppBar";
  import moment from "moment";

  export default {
    components: { AppBar, expandedToolbar },
    computed: {
      ...mapGetters([
        "dateRange",
        "currentUser",
        "triggerEvents",
        "triggerEventsLoading",
        "apiUrl",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      searchEvents: "",
      event: {},
      filter: {
        dateRange: [],
      },
      //Dialog Boxes
      viewDetailsDialog: false,
      dateRangeDialog: false,
    }),
    mounted() {
      this.$store.dispatch("loadEvents");
      this.filter.dateRange = this.dateRange;

      // To demonstrate functionality of exposed component functions
      // Here we make focus on the user input
      // this.$refs.address.focus();
    },
    methods: {
      viewDetails(event) {
        this.event = event;
        this.viewDetailsDialog = true;
      },
      setDateRange() {
        this.$store.dispatch("loadDateRange", this.filter.dateRange).then(() => {
          this.$store.dispatch("loadEvents");
        });
        this.dateRangeDialog = false;
      },
      getDateLocal(date) {
        return moment.utc(date).local().format("MMMM Do YYYY, h:mm:ss a");
      },
      downloadEventAttachment(event) {
        this.$store.dispatch("downloadEventAttachment", event);
      },
    },
  };
</script>

<style></style>
